import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Footer } from '../../components/common/Footer';
import { Header } from '../../components/common/Header';
// import { joinStatusTransfer } from '../../components/common/joinStatusTransfer';
import { NotYetEvent } from '../../components/common/NotYetEvent';
import { SubmittedEvent } from '../../components/common/SubmittedEvent';
import { useAsyncEffect } from '../../helper/hooks/async-hooks';
import { department, event, eventJoin, eventType, transfer, notYetEventData, submittedEventData } from '../../types/Reigenspf001';
import { NothingEvent } from '../../components/common/NothingEvent';
import { SubmittedFlag } from '../../components/common/StatusContext';
import { getNotYetEventData } from '../../components/common/getNotYetEventData';
import { getSubmittedEventData } from '../../components/common/getSubmittedEventData'
import { ReadQRCodeModal } from '../../components/event/ReadQRCodeModal'
import { useCookies } from 'react-cookie';


/**
 * 例会参加者管理システム マイページ画面
 * @returns
 */
export function Reigenspf0001() {

  //    未申込のイベントリストを保持するstate
  const [notYetEventData, setNotYetEventData] = useState<notYetEventData[]>([]);
  //    申込済みのイベントリストを保持するstate
  const [submittedEventData, setSubmittedEventData] = useState<submittedEventData[]>([])

  //   ページ遷移用のnavigate
  const navigate = useNavigate();

  //   モダールの状態を保存するstate
  const [isModal, setIsModal] = useState<boolean>(false);

  //    未申込/申込済みタブの切替を保持するコンテキスト
  const submittedFlag = useContext(SubmittedFlag);

  //  アカウントIDを保存するcookie
  const [cookieAccId, setCookieAccId, removeCookieAccId] = useCookies(['idCookie']);
  //  対応会員番号を保存するcookie（秘書の場合のみ）
  const [cookieSecAccId, setCookieSecAccId, removeCookieSecAccId] = useCookies(['secIdCookie'])
  //  ロータリーCDを保存するcookie
  const [cookieRotaryCd, setCookieRotaryCd, removeCookieRotaryCd] = useCookies(['rotaryCookie'])

  //  初回レンダリング時、イベント情報を取得する
  useAsyncEffect(async () => {

    //  API呼び出し時のパラメータ
    let param
    
    //  対応会員番号を取得できた場合、パラメータに設定
    if(cookieSecAccId.secIdCookie != null){
      param = cookieSecAccId.secIdCookie
    
    }else{
      //  取得できなかった場合、アカウントIDをパラメータに設定
      param = cookieAccId.idCookie
    }

    //  未申込のイベントのリストを取得
    const notyet = await getNotYetEventData({
        id: param,
        rotaryCd: cookieRotaryCd.rotaryCookie
    });
    setNotYetEventData(notyet)

    //  申込済みのイベントのリストを取得
    const submitted = await getSubmittedEventData({
      id: param,
      rotaryCd: cookieRotaryCd.rotaryCookie
    });
    setSubmittedEventData(submitted)
  
  }, []);

  //QR読込み押下時モーダルの表示切替
  const changeModal = (status : boolean) => {
    setIsModal(status);
  }
  
  return (
    <div className={`l-wrapper sp-view ${isModal === true ? "is-modal" : ""} is-myPage`}>
      <main className="l-contents">
        <Header />
        <div className="l-default-content">
          <div className="l-inner">
            <div className="l-title">
              <h2 className="title-txt">マイページ</h2>
            </div>
            <div className="l-record-wrap">
              <div className="list-title flex-outside">
                <h2 className="ttl">イベント</h2>
                {/*  秘書IDが存在しない場合のみQR読込みボタンを表示*/}
                {(!cookieSecAccId.secIdCookie) &&
                <button 
                  type="button" 
                  className="btn-sub btnsz-auto head-abs"
                  onClick={() =>{changeModal(true);}}
                >
                  <i className="ic-qr"></i>
                  QR読込み
                </button>
                }
              </div>
            </div>

            <div className="l-tab-btn">
              {/* 未申込と申込済みのイベントの表示を切り替えるボタン*/}
              <div
                className={`tab-btn ${!submittedFlag.isSubmitted && "is-current"}`}
                onClick={() => {
                  submittedFlag.changeSubmitted(false)
                }}
              >
                未申込
              </div>
              <div
                className={`tab-btn ${submittedFlag.isSubmitted && "is-current"}`}
                onClick={() =>{
                  submittedFlag.changeSubmitted(true)
                }}
              >
                申込済み
              </div>
            </div>
            <div className="l-tab-wrap">

            {/* APIから取得してきた　未申込のイベント*/}
            {!submittedFlag.isSubmitted && (
              notYetEventData.length === 0 ?
                <NothingEvent  
                isSubmitted={submittedFlag.isSubmitted}
                />
              :
                notYetEventData.map( (elements, index) => {
                    return(
                      <NotYetEvent
                        key={elements.event_code}
                        event_id={elements.event_id}
                        event_code={elements.event_code}
                        subject= {elements.subject}
                        url={elements.url}
                        event_type_name={elements.event_type_name}
                        icon_class={elements.icon_class}
                        limit_date={elements.limit_date}
                        limit_time={elements.limit_time}
                        date={elements.date}
                        from_time={elements.from_time}
                        to_time={elements.to_time}
                        location={elements.location}
                        department_name={elements.department_name}
                        member_fee={elements.member_fee}
                      />
                    );
                  })
            )}

            {/* APIから取得してきた　申込済みのイベント*/}
            {submittedFlag.isSubmitted && (
              submittedEventData.length === 0 ? 
                <NothingEvent  
                  isSubmitted={submittedFlag.isSubmitted}
                />
                :
                submittedEventData.map( (elements, index) => {
                      return(
                        <SubmittedEvent
                          key={elements.event_id}
                          event_id={elements.event_id}
                          event_code={elements.event_code}
                          subject= {elements.subject}
                          url={elements.url}
                          event_type_id={elements.event_type_id}
                          event_type_name={elements.event_type_name}
                          icon_class={elements.icon_class}
                          date={elements.date}
                          from_time={elements.from_time}
                          to_time={elements.to_time}
                          location={elements.location}
                          department_name={elements.department_name}
                          member_fee={elements.member_fee}
                          join_flag={elements.join_flag}
                          cancel_waiting_flag={elements.cancel_waiting_flag}
                        />
                      );
                  }
                )
            )}
            </div>
          </div>
        </div>

         {/*  QRコード読込みモーダル（秘書IDが存在しない場合のみ表示）*/}
         {isModal && (!cookieSecAccId.secIdCookie) &&
                    <ReadQRCodeModal
                        isModal={isModal}
                        setIsModal={setIsModal}
                        cookieAccId={cookieAccId.idCookie}
                        cookieRotaryCd={cookieRotaryCd.rotaryCookie}
                    />
          }
      </main>
      <Footer />
    </div>
  );
}
